module.exports = __webpack_public_path__ + "static/air_quality_visualizer-7cc400e87ccf2d0ed5bb9e86a5aa5cc8.png";